<div class="knowledge-base">
  <!-- ── Header ─────────────────────────────────────────────────────────── -->
  <ui-page-header [title]="'knowledge_base.title' | translate" lucideIcon="Book"> </ui-page-header>

  <!-- ── Level 1 tabs. Products leads and is the landing tab. ───────────── -->
  <div class="knowledge-base__tabs">
    <div
      class="knowledge-base__tab"
      role="tab"
      [attr.aria-selected]="activeL1Tab === 'products'"
      [class.active]="activeL1Tab === 'products'"
      (click)="onL1TabChange('products')"
    >
      {{ "knowledge_base.tab.products" | translate }}
    </div>
    <div
      class="knowledge-base__tab"
      role="tab"
      [attr.aria-selected]="activeL1Tab === 'documents'"
      [class.active]="activeL1Tab === 'documents'"
      (click)="onL1TabChange('documents')"
    >
      {{ "knowledge_base.tab.documents" | translate }}
    </div>
    <div
      class="knowledge-base__tab"
      role="tab"
      [attr.aria-selected]="activeL1Tab === 'locations'"
      [class.active]="activeL1Tab === 'locations'"
      (click)="onL1TabChange('locations')"
    >
      {{ "knowledge_base.tab.locations" | translate }}
    </div>
    <div
      class="knowledge-base__tab"
      *ngIf="pricingEnabled"
      role="tab"
      [attr.aria-selected]="activeL1Tab === 'pricing'"
      [class.active]="activeL1Tab === 'pricing'"
      (click)="onL1TabChange('pricing')"
    >
      {{ "knowledge_base.tab.pricing" | translate }}
    </div>
  </div>

  <!-- ── Products tab content ─────────────────────────────────────────── -->
  <app-products-tab *ngIf="activeL1Tab === 'products'"></app-products-tab>

  <!-- ── Documents tab content ──────────────────────────────────────────
       *ngIf, not [hidden]: the tab dispatches LoadDocuments() on init, and
       since Products became the landing tab that request would fire on every
       visit to Knowledge for a tab most users never open. Filters, sort and
       the document list live in the store, so they survive the unmount. -->
  <app-documents-tab *ngIf="activeL1Tab === 'documents'"></app-documents-tab>

  <!-- ── Locations tab content (WB-7570) ─────────────────────────────────
       Same *ngIf-not-[hidden] rationale as Documents: LoadLocationShipping
       Exclusions() only fires when an admin actually opens this tab. -->
  <app-locations-tab *ngIf="activeL1Tab === 'locations'"></app-locations-tab>

  <!-- ── Pricing observations tab content. Gated on the pricing addon. ── -->
  <app-pricing-tab *ngIf="pricingEnabled && activeL1Tab === 'pricing'"></app-pricing-tab>
</div>
